
export enum ModalType {
    Standard = 'Standard',
    Delete = 'Delete'
}